import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthModel} from '../../models/main/auth.model';
import {SessionModel} from '../../models/main/session.model';
import {DeviceDetectorService} from 'ngx-device-detector';
import {configApp} from '../../configapp/config';
import {CookieService} from 'ngx-cookie';

const API_URL = 'app/auth';

@Injectable({
	providedIn: 'root' // il permet d'ajouter ce guard dans les providers 'global' de l'app
})

export class AuthService {

	constructor(private http: HttpClient, private deviceService: DeviceDetectorService,
				private cookieService: CookieService) {
	}


	// demander changement de mot de passe
	nouveaumotdepasse(pin: string) {
		return this.http.post<AuthModel>(`${API_URL}/nouveaumotdepasse`, {pin: pin}).pipe(
			catchError(
				(err) => {
					let obj: any = {_erreur: err.error};
					return of(obj);
				}
			)
		);
	}

	// demander changement de mot de passe
	motdepasseoublie(username: string) {
		return this.http.post<AuthModel>(`${API_URL}/motdepasseoublie`, {username: username}).pipe(
			catchError(
				(err) => {
					let obj: any = {_erreur: err.error};
					return of(obj);
				}
			)
		);
	}

	// Renvoyer le code sécurité
	renvoyerPin(username: string) {
		return this.http.post<AuthModel>(`${API_URL}/renvoyerpin`, {username: username}).pipe(
			catchError(
				(err) => {
					let obj: any = {_erreur: err.error};
					return of(obj);
				}
			)
		);
	}


	// debloquer compte verouillé
	debloquer(username: string, codepin: string) {
		return this.http.post<AuthModel>(`${API_URL}/debloquer`, {username: username, pin: codepin}).pipe(
			catchError(
				(err) => {
					let obj: any = {_erreur: err.error};
					return of(obj);
				}
			)
		);
	}

	// demander l'authentification
	login(email: string, password: string): Observable<AuthModel> {

		return this.http.post<AuthModel>(`${API_URL}/login`, {email, password, session: this.getSession()}).pipe(
			catchError(
				(err) => {
					let obj: any = {_erreur: err.error};
					return of(obj);
				}
			)
		);
	}


	// recuperer l'authentification par uid
	getAuthByUid(uid: string): Observable<AuthModel> {

		return this.http.post<AuthModel>(`${API_URL}/uid`, {uid: uid}).pipe(
			catchError(
				(err) => {
					let obj: any = {_erreur: err.error};
					return of(obj);
				}
			)
		);
	}

	// vérifier si l'utilisateur est bien connecté
	estConnecte() {
		const login = localStorage.getItem('auth');
		const uid = this.getUid();
		let logout = this.cookieService.get('logout');

		if(logout == '1'){
			this.supprimerLoginDuLocal();
			return false;
		}else{
			if(login == null && uid == undefined){
				return false;
			}
			return true;
		}
	}


	// demander les déconnexion
	logout() {
		this.supprimerLoginDuLocal();
		location.reload();
	}


	// LOCAL STORAGE
	// Enregistrer les param de connexion en navigateur local
	enregistrerLoginEnLocal(login: AuthModel) {
		localStorage.setItem('auth', JSON.stringify(login));
		if(login.uid){
			// stocker dans cookie
			this.setUid(login.uid);
			this.cookieService.put('logout', '0');
		}
	}

	// Récupérer les param de connexion en navigateur local
	recupererLoginDuLocal(): AuthModel {
		let auth = localStorage.getItem('auth');
		let login = new AuthModel();
		if (auth) {
			login = JSON.parse(auth);
		}
		return  login;

	}

	// Supprimer les param de connexion en navigateur local
	supprimerLoginDuLocal() {
		this.cookieService.remove('uid');
		this.cookieService.put('logout', '1');
		return localStorage.removeItem('auth');
	}


	// Errors
	private handleError(erreur) {
		//this.toastr.error(erreur.message, erreur.status + ' : ' + erreur.statusText);
		return throwError(erreur);

	}


	// info session
	getSession(): SessionModel {
		let session = new SessionModel();
		session.userAgent = this.deviceService.userAgent;
		session.os = this.deviceService.os;
		session.osVersion = this.deviceService.os_version;
		session.device = this.deviceService.device;
		session.browser = this.deviceService.browser;
		session.browserVersion = this.deviceService.browser_version;
		session.isDesktop = this.deviceService.isDesktop();
		session.isMobile = this.deviceService.isMobile();
		session.isTablet = this.deviceService.isTablet();
		session.service = configApp.NomApp;

		return session;
	}


	setDossier(dossier:string){
		let login = this.recupererLoginDuLocal();
		login.dossier= dossier;
		this.enregistrerLoginEnLocal(login);
	}


	getUid(): string{
		return this.cookieService.get('uid');
	}

	setUid(val: string) {
		this.cookieService.put('uid', val);
	}


}
